import { useEffect, useState } from 'react';

/**
 * ClientOnly wrapper component that prevents hydration mismatches
 * by only rendering children after the component has mounted on the client.
 */
export default function ClientOnly({ children, fallback = null }) {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return fallback;
  }

  return children;
}
